const wrap = 'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8';

export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden="true" className={`animate-pulse rounded-lg bg-ink/10 ${className}`} />;
}

function Status({ className = '', children }: { className?: string; children: React.ReactNode }) {
  return <div role="status" aria-busy="true" aria-label="Loading" className={className}>{children}</div>;
}

const Row = () => (
  <div className="flex items-center gap-5 py-6 border-b border-line">
    <Skeleton className="w-20 h-20 sm:w-28 sm:h-28 flex-none rounded-2xl" />
    <div className="flex-1 space-y-3"><Skeleton className="h-6 w-1/2" /><Skeleton className="h-4 w-3/4" /></div>
  </div>
);

/** Project / career list rows. */
export function RowsSkeleton({ count = 5 }: { count?: number }) {
  return <Status>{Array.from({ length: count }, (_, i) => <Row key={i} />)}</Status>;
}

export function HomeSkeleton() {
  return (
    <Status className={`${wrap} pt-32 pb-20`}>
      <div className="flex flex-wrap items-center gap-10">
        <div className="flex-1 basis-[320px] space-y-5">
          <Skeleton className="h-16 w-4/5" /><Skeleton className="h-6 w-1/3" /><Skeleton className="h-4 w-full" /><Skeleton className="h-4 w-5/6" />
          <div className="flex gap-3 pt-2"><Skeleton className="h-11 w-36 rounded-full" /><Skeleton className="h-11 w-36 rounded-full" /></div>
        </div>
        <Skeleton className="w-56 h-72 rounded-3xl" />
      </div>
      <Skeleton className="mt-16 h-72 w-full rounded-3xl" />
      <div className="mt-12">{Array.from({ length: 3 }, (_, i) => <Row key={i} />)}</div>
    </Status>
  );
}

export function ProjectSkeleton() {
  return (
    <Status className={`${wrap} pt-28 pb-20`}>
      <div className="flex flex-wrap items-center gap-8">
        <Skeleton className="w-32 h-32 sm:w-40 sm:h-40 rounded-[32px]" />
        <div className="flex-1 basis-[320px] space-y-4"><Skeleton className="h-14 w-2/3" /><Skeleton className="h-5 w-full max-w-xl" /><Skeleton className="h-11 w-40 rounded-full" /></div>
      </div>
      <Skeleton className="mt-12 h-20 w-full" />
      <Skeleton className="mt-10 w-full aspect-[21/9] rounded-3xl" />
      <div className="mt-14 space-y-3"><Skeleton className="h-4 w-full" /><Skeleton className="h-4 w-full" /><Skeleton className="h-4 w-2/3" /></div>
    </Status>
  );
}

/** Stacked form cards, same grid as FormShell. */
export function FormSkeleton() {
  return (
    <Status className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_300px] items-start">
      <div className="space-y-6">
        <Skeleton className="h-36 w-full rounded-2xl" /><Skeleton className="h-56 w-full rounded-2xl" /><Skeleton className="h-44 w-full rounded-2xl" />
      </div>
      <div className="hidden lg:block space-y-4"><Skeleton className="h-28 rounded-2xl" /><Skeleton className="h-11 rounded-full" /></div>
    </Status>
  );
}
